import {Injectable} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {Subject} from "rxjs";
import {IFormField} from "../../../../../shared/components/form-field-wrapper/form-field-wrapper.component";

@Injectable()
export class PopulationRulesService {
  populationRulesFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  formChanges: {}; // number of unsaved from controls
  globalAnsChanges: {};
  unsavedControls: number; // number of unsaved from controls
  originalData: any;
  dependantMandatoryChanged: Subject<{ mandatory: boolean, question: IFormField }> = new Subject<{ mandatory: boolean, question: IFormField }>();

  constructor() {
  }

  initPopulationRulesChanges(data: UntypedFormGroup, globalAnschanges: {}) {
    this.populationRulesFormGroup = data;
    this.globalAnsChanges = globalAnschanges;
  }

  initUnsavedControls(formChanges: {}, count: number) {
    this.formChanges = formChanges;
    this.unsavedControls = count;
  }


  initOriginalRules(data: any) {
    this.originalData = data;
  }

  // get full original question
  getQuestion(id: number) {
    let q;
    this.originalData.populationClientRules.forEach(c => {
      c.clientQuestions.forEach(_q => {
        if (_q.id === id) q = _q
      })
    });
    return q;
  }

}
